import React from 'react';
import { translate } from '../../../common/intl';
import KendoDataGridShell from '../../components/KendoDataGrid/KendoDataGridShell';

const SERIALS_COLUMNS = [
  { id: 'index', title: 'form.builder.serials.item', width: 55 },
  { id: 'serialNumber', title: 'form.builder.serials.serial.number' },
  { id: 'status', title: 'form.builder.serials.status', width: 160 },
  { id: 'usage', title: 'form.builder.serials.usage', width: 150 },
  { id: 'notes', title: 'form.builder.serials.notes' },
] as const;

const FBMPIProcedureItemSerialsTablePlaceholder: React.FC = () => (
  <div>
    <KendoDataGridShell
      columns={SERIALS_COLUMNS.map((column) => ({
        id: column.id,
        title: translate(column.title),
        width: 'width' in column ? column.width : undefined,
      }))}
    />
  </div>
);

export default FBMPIProcedureItemSerialsTablePlaceholder;
